import React from "react";
import "./css/LoadingSpinner1.css";

function spinnder({ size, thickness }) {
  return (
    <div
      className="lds-ring"
      style={{
        width: `${size}rem`,
        height: `${size}rem`,
      }}
    >
      <div
        style={{
          width: `${size * 0.8}rem`,
          height: `${size * 0.8}rem`,
          margin: `${size * 0.1}rem`,
          borderWidth: `${thickness}rem`,
        }}
      ></div>
      <div
        style={{
          width: `${size * 0.8}rem`,
          height: `${size * 0.8}rem`,
          margin: `${size * 0.1}rem`,
          borderWidth: `${thickness}rem`,
        }}
      ></div>
      <div
        style={{
          width: `${size * 0.8}rem`,
          height: `${size * 0.8}rem`,
          margin: `${size * 0.1}rem`,
          borderWidth: `${thickness}rem`,
        }}
      ></div>
      <div
        style={{
          width: `${size * 0.8}rem`,
          height: `${size * 0.8}rem`,
          margin: `${size * 0.1}rem`,
          borderWidth: `${thickness}rem`,
        }}
      ></div>
    </div>
  );
}

export default spinnder;
